import { Dispatch } from "redux";

interface SubscriptionAction {
  type: string;
  key: string;
  componentEthCalls?: any[];
  componentApiCalls?: any[];
  clockCount?: number;
  [key: string]: any;
}

interface Transaction {
  state?: string;
}

export function addRemoveSub(
  dispatch: Dispatch,
  key: string,
  apiCalls: any[],
  ethCalls: any[],
  apiClock: number,
  ethClock: number
): () => void {
  dispatch({
    type: "ETH_ADD_SUBSCRIPTION",
    key: key,
    componentEthCalls: ethCalls,
    clockCount: ethClock,
  } as SubscriptionAction);
  dispatch({
    type: "API_ADD_SUBSCRIPTION",
    key: key,
    componentApiCalls: apiCalls,
    clockCount: apiClock,
  } as SubscriptionAction);
  return () => {
    dispatch({ type: "ETH_REMOVE_SUBSCRIPTION", key: key } as SubscriptionAction);
    dispatch({ type: "API_REMOVE_SUBSCRIPTION", key: key } as SubscriptionAction);
  };
}

export function isTransactionValid(lastTransaction: Transaction | null | undefined): boolean {
  return !lastTransaction || !(lastTransaction && !lastTransaction.state && lastTransaction.state !== "QUEUED");
}
